import { memo } from "react";

const TRUST_ITEMS = [
  { text: "Upto 20% OFF on all spiritual products", highlight: true },
  { text: "100% Natural & Authentic", highlight: true },
  { text: "Free Shipping on Every Order", highlight: false },
  { text: "10,000+ Happy Customers", highlight: true },
  { text: "Energised by Astrologers", highlight: false },
  { text: "COD Available", highlight: true },
];

const TrustBadgesStrip = memo(() => {
  return (
    <div className="md:hidden bg-gradient-to-r from-orange-600 to-yellow-600 py-2.5 overflow-hidden">
      <div className="animate-marquee whitespace-nowrap flex items-center">
        {[...TRUST_ITEMS, ...TRUST_ITEMS].map((item, index) => (
          <span key={index} className="inline-flex items-center mx-6">
            <span className="text-white text-xs font-medium">
              {item.text}
            </span>
            <span className="ml-6 text-white/60">•</span>
          </span>
        ))}
      </div>
    </div>
  );
});

TrustBadgesStrip.displayName = "TrustBadgesStrip";

export default TrustBadgesStrip;
